import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { getTopicSlug } from 'src/app/pages/tag/api/topics';
import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'tag',
		path: '/t/:slug',
		beforeServerRender: async ({ utilities, redirect, params: { slug } }) => {
			const topicSlug = await getTopicSlug(slug, utilities);

			if (topicSlug) {
				redirect(`/topic/${slug}`, true);
			}
		},
		component: loadable(async () => import(/* webpackChunkName: "pages/tag" */ './index'), {
			exportName: 'Tag',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: true,
		},
	},
];
